import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Header, Modal, Icon } from 'semantic-ui-react';

import { Affiliation } from '@/types/affiliation';
import { getFullName } from '@/utils/name';
import { AnchorLike } from '@/components/shared/AnchorLike';

type Props = {
  children?: never;
  affiliation: Affiliation;
  onClickDelete: (id: number) => void;
};

export const DeleteMembership: React.FC<Props> = (props) => {
  const { affiliation, onClickDelete } = props;
  const [isOpen, setIsOpen] = useState(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);

  const { t } = useTranslation();
  const { admin, role } = affiliation;
  const adminFullName = getFullName(admin.firstName, admin.lastName);

  return (
    <Modal
      dimmer="blurring"
      trigger={
        <AnchorLike onClick={open}>
          <Icon
            data-test="delete-affiliation"
            name="remove"
            alt={t('ui.action.delete')}
          />
          <span>{t('ui.action.delete')}</span>
        </AnchorLike>
      }
      open={isOpen}
    >
      <Header content={t('ui.confirm.deleteMembership')} />
      <Modal.Content>
        <div>
          {adminFullName ? adminFullName : admin.email}（
          {t(`models.affiliation.roleType.${role}.name`)}）
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button data-test="cancel" onClick={close}>
          {t('ui.action.cancel')}
        </Button>
        <Button
          color="red"
          data-test="execute"
          onClick={() => {
            onClickDelete(admin.id);
            close();
          }}
        >
          {t('ui.action.deleteNow')}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
